import _ from 'underscore'
import React from 'react'
import PropTypes from 'prop-types'

import Form from '../elements/Form'
import IntegerInput from '../elements/forms/IntegerInput'
import Dismissible from '../elements/Dismissible'
import AppConstants from '../../utils/AppConstants'
import AppUtils from '../../utils/AppUtils'

const ERROR = {
  EMPTY_DIAMETER: 'Le diamètre ne peut pas être vide.'
}

class DiameterForm extends React.Component {

  constructor(props) {

    // Properties
    super(props)

    // State
    this.state = {
      input: this.getInitialInput(props),
      formErrors: []
    }

    // Bind events
    this.onChangeInputDiameter = this.onChangeInputDiameter.bind(this)
    this.onSubmit = this.onSubmit.bind(this)

    // Register submit event
    if (_.isFunction(this.props.registerSubmit)) {
      this.props.registerSubmit(this.onSubmit)
    }
  }

  getInitialInput(props = this.props) {
    return {
      diameter: (props.data && props.data.diameter) || ''
    }
  }

  setInput(input = {}) {
    this.setState((prevState, props) => ({
      input: _.extend(
        {},
        prevState.input,
        input
      )
    }))
  }

  componentDidUpdate(prevProps, prevState) {
    // When async fetch finished
    if (prevProps.isLoading && !this.props.isLoading) {
      this.setState({
        input: this.getInitialInput()
      })
    }
  }

  onChangeInputDiameter(diameter) {
    this.setInput({ diameter })
  }

  onSubmit() {
    // Check that fields have been filled
    const formErrors = []
    if (!_.isNumber(this.state.input.diameter) || String(this.state.input.diameter).length === 0) {
      formErrors.push(ERROR.EMPTY_DIAMETER)
    }
    this.setState({
      formErrors
    })
    if (!_.isEmpty(formErrors)) {
      return;
    }

    // Build and submit correctly formatted input
    this.props.onSubmit(this.state.input)
  }

  render() {
    return (
      <React.Fragment>
        {
          this.props.error
            ? <Dismissible
                header={AppUtils.errorToTitle(this.props.error)}
                content={AppUtils.errorToText(this.props.error, {
                  [AppConstants.ERROR.BAD_REQUEST.UNICITY_CONSTRAINT_VIOLATION]: 'Ce diamètre existe déjà.'
                })}
                color='red'
                onDismiss={this.props.onClearError}
              />
            : null
        }
        {
          !_.isEmpty(this.state.formErrors)
            ? <Dismissible
                content='Veuillez résoudre les problèmes ci-dessous avant de poursuivre.'
                color='orange'
              />
            : null
        }
        <Form
          onSubmit={this.onSubmit}
          loading={this.props.isLoading || this.props.isSaving}
        >
          <IntegerInput
            label='Diamètre (mm)'
            placeholder='123'
            value={this.state.input.diameter}
            onChange={this.onChangeInputDiameter}
            error={
              _.contains(this.state.formErrors, ERROR.EMPTY_DIAMETER)
                ? ERROR.EMPTY_DIAMETER
                : null
            }
          />
        </Form>
      </React.Fragment>
    )
  }
}

DiameterForm.propTypes = {
  data: PropTypes.object,
  onSubmit: PropTypes.func.isRequired,
  onClearError: PropTypes.func.isRequired,
  isLoading: PropTypes.bool.isRequired,
  isSaving: PropTypes.bool.isRequired,
  registerSubmit: PropTypes.func,
  error: PropTypes.object
}

export default DiameterForm



// WEBPACK FOOTER //
// ./src/components/forms/DiameterForm.js